import { connect } from "react-redux";
import PdcsList from "./PdcsList";
import { init, setSort } from "../../../redux/actions/pdcActions";
import { selectRanges } from "../../../redux/selectors/pdcsSelector";
const mapStateToProps = state => {
  return {
    currentFilters: state.pdcs.currentFilters,
    pdcs: state.pdcs ? state.pdcs.pdcsList || [] : null,
    currentPage: state.pdcs ? state.pdcs.currentPage : null,
    totalPage: state.pdcs ? state.pdcs.totalPage : null,
    hasNext: state.pdcs ? state.pdcs.hasNext : null,
    listBanner: state.pdcs ? state.pdcs.metrics : {},
    token: state.auth.token,
    currentClient: state.currentClient ? state.currentClient.id : null
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: () => {
      dispatch(init());
    },
    setSort: (column, sortOrder) => dispatch(setSort({ column: column, sortOrder: sortOrder }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PdcsList);



// WEBPACK FOOTER //
// src/containers/metier/pdcs/PdcsContainer.js